module.exports = __webpack_public_path__ + "assets/img/recommend_icon07.01221fe4.png";